import { useApolloClient, useQuery } from "@apollo/client";
import { faFileCircleMinus } from "@fortawesome/free-solid-svg-icons";
import { CollapsibleSection } from "Components/CollapsibleSection";
import { SmallIconButton } from "Components/Icon";
import * as DateFns from "date-fns";
import {
  approvalRequiredApplicationsQuery,
  archiveApplicationMutation,
  QuoteEligibility,
} from "generated/graphql";
import React from "react";
import {
  formatDollarsAndCents,
  formatShortUIDate,
  hasValueFn,
  hv,
  sortBy,
} from "Tools";
import { AdminPaths } from "Views/Paths";

export function ApprovalsCollapsible() {
  const client = useApolloClient();
  const { data, refetch } = useQuery(approvalRequiredApplicationsQuery, {
    variables: {
      touchedAfter: DateFns.subDays(DateFns.startOfDay(new Date()), 60),
    },
  });
  const applications = data?.approvalRequiredApplications
    .filter(app => app.eligibility === QuoteEligibility.NEEDS_APPROVAL)
    .toSorted(sortBy(app => app.case?.caseName.toLowerCase()));

  const approvalCount = applications?.length ?? null;
  const countText = approvalCount ?? "Loading...";

  return (
    <CollapsibleSection
      title={`Applications Requiring Approval (${countText})`}
      isDisabled={approvalCount === 0 || !hv(approvalCount)}
    >
      {applications?.toSorted(sortBy(a => a.dateStarted)).map((app, i) => (
        <div key={app.id} style={i === 0 ? undefined : { marginTop: "1em" }}>
          <SmallIconButton
            onClick={async () => {
              if (
                !window.confirm(
                  `Archive application for ${app.applicant.fullName} - ${app.applicant.companyName}?`,
                )
              ) {
                return;
              }
              await client.mutate({
                mutation: archiveApplicationMutation,
                variables: { input: { id: app.id } },
              });
              void refetch();
            }}
            icon={faFileCircleMinus}
            buttonStyle={{
              marginRight: 5,
              verticalAlign: "middle",
              color: "#555",
            }}
          />
          <a href={AdminPaths.ApplicationDetails({ app })}>
            {hasValueFn(app.dateStarted, formatShortUIDate)}{" "}
            <strong>
              {hasValueFn(app.case?.policyLimit, formatDollarsAndCents) ??
                "No Limit Set"}
            </strong>{" "}
            - {app.case?.caseName ?? "No Case Name"}
          </a>
        </div>
      ))}
    </CollapsibleSection>
  );
}
